// @ts-nocheck
import { Stack, Typography } from '@mui/material';
import PhoneInput from 'components/__v2__/PhoneInput';
import { FIELD_TYPES } from 'pages/Forms/RegisterForm/CustomFormBuilder/config/constant';
import { SignatureFieldPreview } from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/Preview/SignatureFieldPreview/SignatureFieldPreview';
import TextPreview from './components/TextPreview';
import ChoicePreview from './components/ChoicePreview';
import DateTimePreview from './components/DateTimePreview';
import AttachmentPreview from './components/AttachmentPreview';
import CheckboxPreview from './components/CheckboxPreview';
import AddressPreview from './components/AddressPreview';
import { MultiSignatureFormFieldPreview } from '../../MultiSignatureFormFieldPreview/MultiSignatureFormFieldPreview';
import { InstructionResult } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/fields/InstructionResult/InstructionResult';
import { SelectPreview } from './components/SelectPreview';
import { CannotBePrefilledElement } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/CannotBePrefilledElement';

const TableCellPreview = ({
  field,
  error,
  tableId,
  tableType,
  rowIndex,
  colIndex,
  updateAnswer,
  updatePreviewColumn,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
  prefilledElementIDs,
}) => {
  let cell = null;
  const cellShouldBeReadonly =
    shouldBeReadOnly && prefilledElementIDs.includes(field?.id);

  switch (field?.type) {
    case field?.name === 'Address' && FIELD_TYPES.TEXT:
      cell = (
        <AddressPreview
          field={field}
          tableId={tableId}
          tableType={tableType}
          rowIndex={rowIndex}
          colIndex={colIndex}
          updateAnswer={updateAnswer}
          updateAnswerInPrefilledElements={updateAnswerInPrefilledElements}
          shouldBeReadOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.TEXT:
    case FIELD_TYPES.NUMBER:
    case FIELD_TYPES.EMAIL:
      cell = (
        <TextPreview
          field={field}
          tableId={tableId}
          tableType={tableType}
          rowIndex={rowIndex}
          colIndex={colIndex}
          updateAnswer={updateAnswer}
          updateAnswerInPrefilledElements={updateAnswerInPrefilledElements}
          shouldBeReadOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.INSTRUCTION:
      cell = <InstructionResult item={field} tableType={true} />;
      break;
    case FIELD_TYPES.PHONE:
      cell = (
        <PhoneInput
          value={field?.answer}
          onChange={(v) => {
            updateAnswer(tableId, rowIndex, colIndex, v);
            if (updateAnswerInPrefilledElements) {
              updateAnswerInPrefilledElements(tableId, v, tableType, '', {
                rowIndex,
                colIndex,
                tableElementType: field?.type,
              });
            }
          }}
          readOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.DATE:
    case FIELD_TYPES.TIME:
    case FIELD_TYPES.DATETIMELLOCAL:
      cell = (
        <DateTimePreview
          field={field}
          tableId={tableId}
          tableType={tableType}
          rowIndex={rowIndex}
          colIndex={colIndex}
          updateAnswer={updateAnswer}
          updateAnswerInPrefilledElements={updateAnswerInPrefilledElements}
          shouldBeReadOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.YESNO:
    case FIELD_TYPES.YESNONA:
    case FIELD_TYPES.RADIOGROUP:
      cell = (
        <ChoicePreview
          field={field}
          tableId={tableId}
          tableType={tableType}
          rowIndex={rowIndex}
          colIndex={colIndex}
          updateAnswer={updateAnswer}
          updatePreviewColumn={updatePreviewColumn}
          updateAnswerInPrefilledElements={updateAnswerInPrefilledElements}
          shouldBeReadOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.CHECKBOX:
      cell = (
        <CheckboxPreview
          field={field}
          tableId={tableId}
          tableType={tableType}
          rowIndex={rowIndex}
          colIndex={colIndex}
          updateAnswer={updateAnswer}
          updatePreviewColumn={updatePreviewColumn}
          updateAnswerInPrefilledElements={updateAnswerInPrefilledElements}
          shouldBeReadOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.MULTIPLESELECT:
    case FIELD_TYPES.DROPDOWN:
      cell = (
        <SelectPreview
          field={field}
          tableId={tableId}
          tableType={tableType}
          rowIndex={rowIndex}
          colIndex={colIndex}
          updatePreviewColumn={updatePreviewColumn}
          updateAnswerInPrefilledElements={updateAnswerInPrefilledElements}
          shouldBeReadOnly={cellShouldBeReadonly}
        />
      );
      break;
    case FIELD_TYPES.FILES:
    case FIELD_TYPES.IMAGES:
      cell = (
        <>
          {updateAnswerInPrefilledElements ? (
            <CannotBePrefilledElement element={field} isTableField={true} />
          ) : (
            <AttachmentPreview
              field={field}
              tableId={tableId}
              rowIndex={rowIndex}
              colIndex={colIndex}
              updateAnswer={updateAnswer}
            />
          )}
        </>
      );
      break;

    case FIELD_TYPES.SIGNATURE:
      cell = (
        <>
          {updateAnswerInPrefilledElements ? (
            <CannotBePrefilledElement element={field} isTableField={true} />
          ) : (
            <SignatureFieldPreview
              element={field}
              tableId={tableId}
              rowIndex={rowIndex}
              colIndex={colIndex}
              updateAnswer={updateAnswer}
            />
          )}
        </>
      );
      break;
    case FIELD_TYPES.MULTISIGNATURE:
      cell = (
        <>
          {updateAnswerInPrefilledElements ? (
            <CannotBePrefilledElement element={field} isTableField={true} />
          ) : (
            <MultiSignatureFormFieldPreview
              element={field}
              tableId={tableId}
              rowIndex={rowIndex}
              colIndex={colIndex}
              updateAnswer={updateAnswer}
            />
          )}
        </>
      );
      break;
  }

  return (
    <Stack direction="column" spacing={1} justifyContent="space-between">
      {cell}
      {error && (
        <Typography
          style={{
            color: 'red',
            fontSize: '0.875rem',
            margin: '5px 0px 0px 10px',
          }}
        >
          {error}
        </Typography>
      )}
    </Stack>
  );
};

export default TableCellPreview;
